"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYCHECK_SAVE_ACTION_COPY = exports.PAYCHECK_CONFIRM_ACTION_COPY = void 0;
/**
 * The paycheck step's two forward buttons, one copy for both apps (Paul, 2026-10-12).
 * They used to promise "build my forecast", but since AN-52 the next screen is
 * "Light or dark?", so they say what happens next instead. "Looks right" stays.
 * Mobile's edit-mode "Save changes" is a different action and keeps its words.
 */
exports.PAYCHECK_CONFIRM_ACTION_COPY = "Looks right, continue";
exports.PAYCHECK_SAVE_ACTION_COPY = "Save and continue";
//# sourceMappingURL=paycheckStepCopy.js.map